export default ($stateProvider) => {
  $stateProvider
    .state('forgot-username', {
      url: `${location.pathname}forgot-username`,
      template: '<nets-forgot-username></nets-forgot-username>',
    });
};
